"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Auth_1 = __importDefault(require("../auth/Auth"));
var config_base_1 = __importDefault(require("../../config/config.base"));
var config_dev_1 = __importDefault(require("../../config/config.dev"));
var config_preprod_1 = __importDefault(require("../../config/config.preprod"));
var config_prod_1 = __importDefault(require("../../config/config.prod"));
var Service = /** @class */ (function () {
    function Service() {
    }
    Service.init = function (client, env) {
        Service.client = client;
        Service.env = env;
        Service.config = Service.getConfig();
        return Service;
    };
    Service.getConfig = function () {
        var configEnv = Service.getConfigEnv();
        return __assign(__assign({}, config_base_1.default), configEnv);
    };
    Service.getConfigEnv = function () {
        switch (Service.env) {
            case 'dev':
                return config_dev_1.default;
            case 'preprod':
                return config_preprod_1.default;
            case 'prod':
                return config_prod_1.default;
        }
    };
    Service.formatAccessTokenHeader = function (accessToken) {
        return accessToken ? "Bearer ".concat(accessToken) : '';
    };
    Service.getDefaultHeaders = function (isAuthenticatedRoute, additionalHeaders) {
        if (isAuthenticatedRoute === void 0) { isAuthenticatedRoute = true; }
        if (additionalHeaders === void 0) { additionalHeaders = {}; }
        return __assign({ client: Service.client, authorization: isAuthenticatedRoute ? Service.formatAccessTokenHeader(Auth_1.default.instance.accessToken) : Auth_1.default.instance.apiToken }, additionalHeaders);
    };
    Object.defineProperty(Service, "baseUrl", {
        get: function () {
            return Service.config.baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Service, "authUrl", {
        get: function () {
            return (Service.config.iam[Service.client] || Service.config.iam['_']).authUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Service, "apiKey", {
        get: function () {
            return (Service.config.iam[Service.client] || Service.config.iam['_']).apiKey;
        },
        enumerable: false,
        configurable: true
    });
    return Service;
}());
exports.default = Service;
